import React from 'react';
import { redirectToExternalPage } from '../../helpers';
import Text from '../General/Text';
import Button from '../General/Button';
import WrapperStyled from './styles/HelperStyled';
import { HelperIcon } from '../../images/consejos-bam';

const Helper = () => {
  return (
    <WrapperStyled>
      <div>
        <HelperIcon />
      </div>
      <Text
        size="18px"
        weight="400"
        color="#494C66"
        lineHeight="20px"
        margin="0px 16px"
        text="Si aún tienes dudas, visita nuestro centro de ayuda para más información"
      />
      <Button
        outline
        color="purple"
        width="280px"
        click={
          () => redirectToExternalPage('https://www.wom.cl/centro-de-ayuda/')
          // eslint-disable-next-line react/jsx-curly-newline
        }
      >
        IR AL CENTRO DE AYUDA
      </Button>
    </WrapperStyled>
  );
};

export default Helper;
